import BaseService from "./Base.Service";
import CompanyService from "./Company.Service";

class AuthService extends BaseService {
  constructor() {
    const model = {
      name: { type: String, required: true },
      email: { type: String, required: true },
      authId: { type: String, required: true },
      companyId: { type: String, required: true },
      role: { type: String, required: true },
      avatar: { type: String },
    };

    super("users", model);

    this.companyService = new CompanyService();
  }

  async loginUser(email, pass) {
    try {
      return await this.conn.loginUser(email, pass);
    } catch (err) {
      console.log(err);
      return this.sendError("Erros foram encontrados ao salvar", false, err);
    }
  }

  async me(query = "") {
    try {
      return await this.conn.me(query);
    } catch (err) {
      console.log(err);
      return this.sendError("Erros foram encontrados ao salvar", false, err);
    }
  }

  async logoutUser() {
    try {
      localStorage.removeItem("idToken_ow");
      localStorage.removeItem("uid_ow");
      return await this.conn.logoutUser();
    } catch (err) {
      console.log(err);
      return this.sendError("Não conseguimos realizar o logout", false, err);
    }
  }

  async createNewUser(userData) {
    try {
     const response =  await this.conn.createUser(userData);
      return response.data;
    } catch (err) {
      console.log(err);
      const backendMsg = err?.response?.data?.msg || err?.response?.data;
      if (backendMsg && typeof backendMsg === 'string') {
        return this.sendError(backendMsg, false, err);
      }
      return this.sendError("Erros foram encontrados ao salvar", false, err);
    }
  }
  async addUser(userData) {
    try {
      await this.conn.addUser(userData);
      return true;
    } catch (err) {
      console.log(err);
      return this.sendError("Erros foram encontrados ao salvar", false, err);
    }
  }
  async generateInvitation() {
    try {
      const response = await this.conn.axios.post(`auth/invitation`);
      return response.data;
    } catch (err) {
      console.log(err);
      return this.sendError("Erro ao gerar convite", false, err);
    }
  }
  async validateInvitation(token) {
    try {
      const response = await this.conn.axios.get(`auth/invitation/${token}`);
      return response.data;
    } catch (err) {
      console.log(err);
      return { valid: false, reason: "error" };
    }
  }
  async switchCompany(companyId) {
    try {
      const response = await this.conn.axios.post(`auth/switch-company`, { companyId });
      return response.data;
    } catch (err) {
      console.log(err);
      return this.sendError("Erro ao trocar empresa", false, err);
    }
  }
  async linkCompany(token) {
    try {
      const response = await this.conn.axios.post(`auth/link-company`, { token });
      return response.data;
    } catch (err) {
      console.log(err);
      // Preservar a mensagem do backend (ex: "Você já está vinculado a esta empresa")
      if (err.response && err.response.data) {
        return err.response.data;
      }
      return this.sendError("Erro ao vincular empresa", false, err);
    }
  }
  async batchAddUser(userData) {
    try {
      const response = await this.conn.axios.post(`/auth/batch/add-user`, userData);
      if (!response) {
        throw new Error("Erro ao cadastrar usuário");
      }
      return response.data;
    } catch (err) {
      console.log(err);
      return this.sendError("Erros foram encontrados ao salvar", false, err);
    }
  }
}

export default AuthService;
